import { Avatar, Col, Row, Text } from 'components';

const ChatItem = ({ owner, text }) => {
  return (
    <Row start marg="12px 0 0 32px">
      <Avatar small user={owner} />

      <Col noFlex marg="0 0 0 12px">
        <Text col="#fff" bold>
          {owner.name}
        </Text>

        <Text col="#fff">{text}</Text>
      </Col>
    </Row>
  );
};

export default ChatItem;
